import {addNotification} from '../notifications';
import {HttpStatus} from '../Constants';

export function notification(state = {}, action) {
    if (action.errorNotification && (!action.error || !action.error.response || action.error.response.status !== HttpStatus.UNAUTHORIZED)) {
        console.error(action.error);
        addNotification({
            message: action.errorNotification,
            level: 'error',
            position: 'tc'
        });
    } else if (action.successNotification) {
        addNotification({
            message: action.successNotification,
            level: 'success',
            position: 'tc'
        });
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/notification.js